export default __webpack_public_path__ + "static/media/YAS0930.34I-42365_-25395_0.9e7fba40.jpg";